module.exports = __webpack_public_path__ + "static/media/journey-left-trees-behind-hill.bbba10b2.svg";